<div class="spacerWrapper" fxLayout="column">
    <h1 mat-dialog-title class="dialogTitle">{{ title }}</h1>

    <div mat-dialog-content>
        <form [formGroup]="userEditorForm" class="grid-container">
            <ng-container *ngIf="!creating">
                <div class="inputContainer userName">
                    <label>Name</label>
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="Name" />
                    </mat-form-field>
                </div>
            </ng-container>

            <ng-container *ngIf="creating">
                <div class="inputContainer userSAPID">
                    <label>SAPID</label>
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="Sapid" (focusout)="formatSAPID()"/>
                    </mat-form-field>
                </div>
            </ng-container>

            <div class="inputContainer userRole">
                <label>Role</label>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="RoleId">
                        <mat-option *ngFor="let role of roles" [value]="role.roleId">
                            {{ role.roleName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>
    </div>

    <div class="spacer" fxFlexFill></div>
    <div class="actions">
        <div class="error-messages" fxLayout="column" fxLayoutAlign="start end">
            <mat-error *ngIf="Sapid.errors?.required && Sapid.touched">
                <mat-icon aria-hidden="false" aria-label="Error: Missing Sapid">error</mat-icon>
                Missing SAPID.
            </mat-error>
            <mat-error *ngIf="Sapid.invalid && Sapid.errors?.maxlength && Sapid.touched">
                <mat-icon aria-hidden="false" aria-label="Error: Too many characters. SAPID must be up to 8 numbers long">error</mat-icon>
                Too many characters. SAPID must be up to 8 numbers long.
            </mat-error>
            <mat-error *ngIf="Sapid.errors?.isSapidTaken && Sapid.touched">
                <mat-icon aria-hidden="false" aria-label="Error: SAPID chosen is already taken.">error</mat-icon>
                SAPID chosen is already taken.
            </mat-error>
        </div>

        <div mat-dialog-actions align="end">
            <button mat-raised-button type="submit" color="primary" (click)="onSubmit(userEditorForm.value)">OK</button>
            <button mat-raised-button type="button" (click)="onNoClick()">Cancel</button>
        </div>
    </div>
</div>
